<template>
  <div>
    <label class="label">{{ label }}:</label>
    <VueMultiselect
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
      :options="options"
      :multiple="true"
      :close-on-select="true"
      :placeholder="placeholder"
      label="name"
      track-by="name"
      class="multiselect-tailwind"
    />
  </div>
</template>

<script setup>
import VueMultiselect from 'vue-multiselect'

defineProps({
  modelValue: { type: Array, required: true },
  options: { type: Array, required: true },
  label: { type: String, required: true },
  placeholder: { type: String, default: 'Select options' }
})

defineEmits(['update:modelValue'])
</script>
